export default __webpack_public_path__ + "static/media/3.7b68b178.jpg";